export function parseJwt(token: string) {
  const parts = token.split(".");
  if (parts.length < 2) {
    throw new Error("Invalid token.");
  }
  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const pad = (4 - (base64.length % 4)) % 4;
  const padded = base64 + "=".repeat(pad);
  return JSON.parse(window.atob(padded));
}

export function trim(s: string, mask: string) {
  if (!s) {
    return s;
  }

  while (~mask.indexOf(s[0])) {
    s = s.slice(1);
  }
  while (~mask.indexOf(s[s.length - 1])) {
    s = s.slice(0, -1);
  }
  return s;
}

export function condenseWhiteSpaces(s: string): string {
  return s.trim().replace(/\s+/g, " ");
}
